// extracted by mini-css-extract-plugin
module.exports = {"link":"NewButton-module__IypI1G__link","container":"NewButton-module__IypI1G__container"};